import React from "react";
import data from "./data.json";
import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import { InfiniteSlider } from "@/components/motion-primitives/infinite-slider";

export default function SideProjectsSm() {
  const ref = useRef(null);
  const { events } = useDraggable(ref);

  return (
    <div
      className="w-full overflow-x-scroll"
      {...events}
      ref={ref}
    >
      <InfiniteSlider gap={12} speedOnHover={1} reverse>
        {data.saasProject.map((projectExp) => {
          const content = (
            <img
              src={projectExp.src}
              alt={projectExp.projectname}
              className="w-auto h-[240px]"
            />
          );

          return (
            <div
              key={projectExp.id}
              className="grayscale-0 hover:saturate-200 hover:scale-[1.02] transition-all duration-300 ease-in-out"
            >
              {projectExp.link !== "#" ? (
                <a
                  href={projectExp.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative pt-2 p-2 rounded-xl flex-shrink-0 w-auto justify-center overflow-y-hidden block"
                >
                  {content}
                </a>
              ) : (
                <div className="relative pt-2 p-2 rounded-xl flex-shrink-0 w-auto justify-center overflow-y-hidden">
                  {content}
                </div>
              )}
            </div>
          );
        })}
      </InfiniteSlider>
    </div>
  );
}